/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import { DataGrid, GridRenderCellParams } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';

import { Content, Header, Page } from '@backstage/core-components';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import { Entity } from '@backstage/catalog-model';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

import {
  alertApiRef,
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import __ from 'lodash';
import { useEffectOnce } from 'react-use';

interface Data {
  id: string;
  name: string;
  image: HTMLImageElement;
}

const EntityForm: React.FC = () => {
  const [components, setComponents] = useState<Entity[]>([]);
  const [selectedComponent, setSelectedComponent] = useState('');

  const [data, setData] = useState<Data[]>([]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const alertApi = useApi(alertApiRef);
  const catalogApi = useApi(catalogApiRef);
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = config.getString('backend.baseUrl');
  const API_URL = `${backendUrl}/api/catalog-image`;

  const fetchDataImages = async () => {
    try {
      const { token } = await identityApi.getCredentials();

      const response = await axios.get(`${API_URL}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      alertApi.post({
        message: 'Error fetchDataImages',
        severity: 'error',
        display: 'transient',
      });
      return undefined;
    }
  };

  const getImages = async () => {
    try {
      const response = await fetchDataImages();
      const transformedData = response.images.map((item: any) => {
        const imageDataUrl = `data:image/jpeg;base64,${Buffer.from(
          item.image_data.data,
        ).toString('base64')}`;

        return {
          id: item.id || '',
          name: item.name || '',
          image: imageDataUrl || '',
        };
      });

      return transformedData;
    } catch (error) {
      alertApi.post({
        message: 'Error getImages',
        severity: 'error',
        display: 'transient',
      });
      return undefined;
    }
  };

  const optionsComponent = components.map(component => ({
    value: component.metadata.name,
    label: `${component.metadata.name}`,
  }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await catalogApi.queryEntities({
          filter: [{ kind: 'component' }],
        });
        setComponents(response.items);
      } catch (error) {
        alertApi.post({
          message: 'Error fetchData',
          severity: 'error',
          display: 'transient',
        });
      }
    };

    fetchData();
  }, [alertApi, catalogApi]);

  const handleComponentChange = async (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setSelectedComponent(value);
  };

  const handleDelete = async (id: string) => {
    try {
      const { token } = await identityApi.getCredentials();

      const response = await axios.delete(`${API_URL}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        alertApi.post({
          message: response.data,
          severity: 'success',
          display: 'transient',
        });
        const dataImg = await getImages();
        setData(dataImg);
      }
    } catch (error) {
      alertApi.post({
        message: 'Error deleting image',
        severity: 'error',
        display: 'transient',
      });
      throw error;
    }
  };

  useEffect(() => {
    const favoritosGuardados = JSON.parse(
      localStorage.getItem('favoritos') || '[]',
    );
    setData(favoritosGuardados);
  }, []);

  interface ImageCellProps {
    imageDataUrl: string;
  }

  const ImageCell: React.FC<ImageCellProps> = ({ imageDataUrl }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
      setIsOpen(true);
    };

    const handleClose = () => {
      setIsOpen(false);
    };

    return (
      <>
        <img
          src={imageDataUrl}
          alt="img catalog"
          width={50}
          height={50}
          className="pointer-events-auto cursor-pointer"
          onClick={handleClick}
        />

        <Dialog open={isOpen} onClose={handleClose}>
          <DialogTitle>Image</DialogTitle>
          <DialogContent>
            <img src={imageDataUrl} alt="Image" style={{ width: '100%' }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const columns = [
    { field: 'name', headerName: 'COMPONENT', width: 320 },
    {
      field: 'image',
      headerName: 'IMAGE',
      width: 150,
      renderCell: (params: GridRenderCellParams<any, any, any>) => (
        <ImageCell imageDataUrl={params.value} />
      ),
    },
    {
      field: 'delete',
      headerName: 'ACTION',
      width: 100,
      renderCell: (params: GridRenderCellParams<any, any, any>) => {
        const { id } = params.row;
        return (
          <Button onClick={() => handleDelete(id)}>
            <Delete color="error" />
          </Button>
        );
      },
    },
  ];

  const fetchData = async () => {
    try {
      const dataImg = await getImages();
      setData(dataImg);
    } catch (error) {
      alertApi.post({
        message: 'Error fetching images',
        severity: 'error',
        display: 'transient',
      });
    }
  };
  useEffectOnce(() => {
    fetchData();
  });

  const uploadFormRef = useRef(null);

  const handleUpload = async (event: { preventDefault: () => void }) => {
    event.preventDefault();

    const formData = new FormData(uploadFormRef.current!);

    const buffers: Buffer[] = [];
    formData.forEach(async (value, _) => {
      if (value instanceof File) {
        const buffer = Buffer.from(await value.arrayBuffer());
        buffers.push(buffer);
      }
    });

    const { token } = await identityApi.getCredentials();

    try {
      const response = await axios.post<{ message: string }>(
        `${API_URL}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        const dataImg = await getImages();
        setData(dataImg);
        setSelectedComponent('');
        alertApi.post({
          message: 'Component Image upload was successful!',
          severity: 'success',
          display: 'transient',
        });
      }
    } catch (error) {
      const resp = __.get(error, 'response.data', '')?.toString();
      alertApi.post({
        message: resp,
        severity: 'error',
        display: 'transient',
      });
    }
  };

  return (
    <div style={{ height: 400, width: '100%' }}>
      <Box sx={{ m: 1, minWidth: 80 }}>
        <Grid item xs={12}>
          <form ref={uploadFormRef} onSubmit={handleUpload}>
            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="component-select-label">Component</InputLabel>
              <Select
                labelId="component-select-label"
                id="name"
                name="name"
                value={selectedComponent}
                onChange={handleComponentChange}
                fullWidth
              >
                {optionsComponent.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
              <TextField
                name="image"
                label=""
                type="file"
                inputRef={fileInputRef}
                fullWidth
              />
            </FormControl>
            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
              <Button type="submit" variant="contained">
                Upload
              </Button>
            </FormControl>
          </form>
        </Grid>
      </Box>
      <Box sx={{ height: '650px', width: '100%' }}>
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          checkboxSelection
        />
      </Box>
    </div>
  );
};

export const CatalogImagePage = () => {
  return (
    <Page themeId="home">
      <Header title="Component Images" pageTitleOverride="Home" />
      <Content>
        <Grid container item xs={12} justifyContent="center">
          <EntityForm />
        </Grid>
      </Content>
    </Page>
  );
};
